module.exports = __webpack_public_path__ + "img/Unidad15-1.07626ebf.png";